import { Button, Card, Typography, Divider } from 'antd';
import {  ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = ({ handleBackToMenu=()=>{} }) => {
  return (
    <div style={{ 
      padding: '24px', 
      maxWidth: '800px', 
      margin: '0 auto',
      height: '100vh', 
      overflowY: 'auto' 
    }}>
      <Button 
        type="text" 
        icon={<ArrowLeftOutlined />}
        onClick={handleBackToMenu}
        style={{ marginBottom: 16 }}
      >
        Back
      </Button>
      <Card style={{ minHeight: '100%' }}>
        <Typography>
          <Title level={2}>Privacy Policy for Queue Tracker App</Title>
          <Text type="secondary">Last Updated: 25/05/2025</Text>
          
          <Divider />
          
          <Paragraph>
            This Privacy Policy explains how <Text strong>quetracker.com</Text> collects, uses, and discloses information when you use our Queue Tracker application.
          </Paragraph>
          
          <Title level={3}>1. Information We Collect</Title>
          <Paragraph>
            <Text strong>For End Users:</Text>
          </Paragraph>
          <Paragraph>
            - <Text strong>Location Data:</Text> We collect your approximate location to show nearby businesses. This data is stored locally on your device.
          </Paragraph>
          <Paragraph>
            - <Text strong>App Usage Data:</Text> We may collect anonymous usage statistics to improve our services.
          </Paragraph>
          
          <Paragraph>
            <Text strong>For Business Owners:</Text>
          </Paragraph>
          <Paragraph>
            - <Text strong>Account Information:</Text> When you register as a business owner, we collect your name, clinic/shop name, email address, mobile number, and business type.
          </Paragraph>
          <Paragraph>
            - <Text strong>Business Location:</Text> We store your business location to display to nearby users.
          </Paragraph>
          <Paragraph>
            - <Text strong>Queue Data:</Text> We store the current queue number and status messages you set through the business panel.
          </Paragraph>
          
          <Title level={3}>2. How We Use Information</Title>
          <Paragraph>
            - To provide and maintain our service
          </Paragraph>
          <Paragraph>
            - To notify you about changes to our service
          </Paragraph>
          <Paragraph>
            - To allow business owners to manage their queue information
          </Paragraph>
          <Paragraph>
            - To show end users nearby businesses and current queue status
          </Paragraph>
          <Paragraph>
            - To gather analysis or valuable information to improve our service
          </Paragraph>
          
          <Title level={3}>3. Data Storage and Security</Title>
          <Paragraph>
            - End user location data is stored locally on your device
          </Paragraph>
          <Paragraph>
            - Business information is stored securely on our servers
          </Paragraph>
          <Paragraph>
            - We implement industry-standard security measures to protect your data
          </Paragraph>
          
          <Title level={3}>4. Data Sharing</Title>
          <Paragraph>
            - Business information (name, location, queue status) is shared with nearby users
          </Paragraph>
          <Paragraph>
            - We do not sell your personal information to third parties
          </Paragraph>
          <Paragraph>
            - We may share aggregated, non-personally identifiable information for analytics purposes
          </Paragraph>
          
          <Title level={3}>5. How to Delete Your Data</Title>
          <Paragraph>
            <Text strong>For All Users:</Text>
          </Paragraph>
          <Paragraph>
            - We only store data for signed up users. To delete your data:
          </Paragraph>
          <Paragraph>
            <Text strong>1.</Text> You can visit "Update Profile" in the app sidebar where you'll find an option to delete your account and all associated data.
          </Paragraph>
          <Paragraph>
            <Text strong>2.</Text> Alternatively, you can email us at <Text code>admin@mail.quetracker.com</Text> with your request to delete your data.
          </Paragraph>
          
          <Title level={3}>6. Your Rights</Title>
          <Paragraph>
            <Text strong>For End Users:</Text>
          </Paragraph>
          <Paragraph>
            - You can disable location access in your device settings
          </Paragraph>
          <Paragraph>
            - You can clear all app data through your device's application settings
          </Paragraph>
          
          <Paragraph>
            <Text strong>For Business Owners:</Text>
          </Paragraph>
          <Paragraph>
            - You can update your profile information through the app
          </Paragraph>
          <Paragraph>
            - You can delete your account and all associated data through the methods described above
          </Paragraph>
          
          <Title level={3}>7. Changes to This Privacy Policy</Title>
          <Paragraph>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy in the app or on our website.
          </Paragraph>
          
          <Title level={3}>8. Contact Us</Title>
          <Paragraph>
            If you have any questions about this Privacy Policy, please contact us at <Text code>admin@mail.quetracker.com</Text> or visit the Contact Us page in the app.
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
};

export default PrivacyPolicy;